<template>
  <div>
    <!-- 供应商资质审核 -->
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 70px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 40px;
          display: flex;
          font-size: 18px;
          font-weight: bold;
          align-items: center;
        "
      >
        <div style="color: #000">
          <span
            style="cursor: pointer"
            @click="
              $router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)
            "
            >{{ backName || '工作台' }}</span
          >
          <i class="el-icon-arrow-right"></i>
        </div>
        <div style="color: #606266" class="ellipsis">供应商资质审核</div>
      </div>
      <div
        style="display: flex; align-items: center; width: 100%; height: 110px"
        class="headData"
        v-loading="dataStatisticsLoading"
      >
        <el-row style="height: 100%; width: 100%" :gutter="20">
          <el-col :span="4" style="height: 100%">
            <el-card style="width: 100%; height: 110px">
              <el-statistic
                :value="Math.round(Number(dataStatistics.deviceCount || 0))"
                :value-style="{
                  fontSize: '24px',
                }"
              >
                <div slot="title">
                  <div
                    style="font-size: 18px; font-weight: bold; color: #e6a23c"
                  >
                    所有资料数量
                  </div>
                </div>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="4" style="height: 100%">
            <el-card style="width: 100%; height: 110px">
              <el-statistic
                :value="
                  Math.round(Number(dataStatistics.TwoSupplierCount || 0))
                "
                :value-style="{
                  fontSize: '24px',
                }"
              >
                <div slot="title">
                  <div
                    style="font-size: 18px; font-weight: bold; color: #e6a23c"
                  >
                    已提交资料数量
                  </div>
                </div>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="4" style="height: 100%">
            <el-card style="width: 100%; height: 110px">
              <el-statistic
                :value="Math.round(Number(dataStatistics.DocumentCount || 0))"
                :value-style="{
                  fontSize: '24px',
                }"
              >
                <div slot="title">
                  <div
                    style="font-size: 18px; font-weight: bold; color: #e6a23c"
                  >
                    已通过资料数量
                  </div>
                </div>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="4" style="height: 100%">
            <el-card style="width: 100%; height: 110px">
              <el-statistic
                :value="Math.round(Number(dataStatistics.AccessoryCount || 0))"
                :value-style="{
                  fontSize: '24px',
                }"
              >
                <div slot="title">
                  <div
                    style="font-size: 18px; font-weight: bold; color: #e6a23c"
                  >
                    驳回资料数量
                  </div>
                </div>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="4" style="height: 100%">
            <el-card
              style="width: 100%; height: 100%; position: relative"
              :body-style="{
                padding: 0,
              }"
            >
              <div
                style="width: 100%; height: calc(100%); margin-top: 60px"
                id="DeviceProgress"
              ></div>
              <div
                style="
                  height: 30px;
                  width: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  text-align: center;
                  font-weight: bold;
                  font-size: 18px;
                  line-height: 30px;
                "
              >
                提交率<span class="hint-text" v-if="SupplyType == '1'"
                  >(乙供)</span
                ><span class="hint-text" v-if="SupplyType == '3'">(甲供)</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4" style="height: 100%">
            <el-card
              style="width: 100%; height: 100%; position: relative"
              :body-style="{
                padding: 0,
              }"
            >
              <div
                style="width: 100%; height: calc(100%); margin-top: 60px"
                id="DocumentProgress"
              ></div>
              <div
                style="
                  height: 30px;
                  width: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  text-align: center;
                  font-weight: bold;
                  font-size: 18px;
                  line-height: 30px;
                "
              >
                通过率<span class="hint-text" v-if="SupplyType == '1'"
                  >(乙供)</span
                ><span class="hint-text" v-if="SupplyType == '3'">(甲供)</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div style="width: 100%; margin-top: 20px">
        <el-table height="calc(100vh - 290px)" :data="dataList">
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            align="center"
            width="350px"
            sortable
          />
          <el-table-column
            prop="cVenPerson"
            label="联系人"
            align="center"
            width="150px"
            sortable
          />
          <el-table-column
            prop="cVenPhone"
            label="联系电话"
            align="center"
            width="150px"
            sortable
          />

          <el-table-column
            prop="InforName"
            label="已上传资料类型"
            show-overflow-tooltip
            sortable
          />
          <el-table-column
            prop="Status"
            label="状态"
            width="120px"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Status == 1" type="warning" size="mini"
                >{{ scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核' }}
              </el-tag>
              <el-tag
                v-if="scope.row.Status == 2 || scope.row.Status == 3"
                type="success"
                size="mini"
                >已审核
              </el-tag>
              <el-tag v-if="scope.row.Status == 4" type="danger" size="mini"
                >驳回
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="审核人"
            prop="Reviewer"
            width="130"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-tag v-for="item in scope.row.Reviewer || []" :key="item">{{
                item
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="AccessoryCode"
            label="操作"
            align="center"
            width="150px"
          >
            <template slot-scope="scope">
              <!-- <el-button type="text" size="mini" @click="openView(scope.row)"
                >详情</el-button
              > -->
              <el-button
                type="text"
                size="mini"
                style="color: #e6a23c"
                @click="auditView(scope.row)"
                >详情</el-button
              >
              <el-button type="text" size="mini" @click="openInfo(scope.row)"
                >记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      :close-on-press-escape="false"
      size="80%"
    >
      <template slot="title">
        <div style="width: 100%; display: flex; align-items: center">
          <el-button
            type="primary"
            @click="drawer = false"
            style="margin-right: 10px"
            >关闭</el-button
          >

          <div>{{ title }}</div>
        </div>
      </template>

      <div
        style="
          width: 100%;
          height: calc(100vh - 120px);
          overflow-y: auto;
          overflow-x: hidden;
          box-sizing: border-box;
          padding: 0 20px;
          display: flex;
        "
        v-loading="drawerLoading"
      >
        <div style="width: calc(100% - 240px)">
          <div v-for="(eell, indexeell) in ProjectTableData" :key="eell.Id">
            <el-table :data="[eell]" style="width: 100%" row-key="Id">
              <el-table-column prop="TypeName" width="200">
                <span slot="header">
                  <span>{{ indexeell + 1 + '.' + eell.TypeName }}</span>
                  <el-popover
                    v-if="
                      ProjectStepList.find((vv) => vv.DicValue == eell.Type)
                        ?.Remark || false
                    "
                    placement="bottom-start"
                    :open-delay="100"
                    width="200"
                    trigger="hover"
                    :content="
                      ProjectStepList.find((vv) => vv.DicValue == eell.Type)
                        ?.Remark || ''
                    "
                    popper-class="table-popper"
                  >
                    <i class="el-icon-question" slot="reference"></i>
                  </el-popover>
                </span>
                <template slot-scope="scope"> {{ '' }} </template>
              </el-table-column>

              <el-table-column
                prop="Type"
                label="上传文件名称"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <div v-for="item in scope.row.DocumentList" :key="item.uid">
                    <el-button type="text" @click="handlePreview(item)">
                      {{ item.resname }}
                    </el-button>
                  </div>
                  <span v-if="scope.row.DocumentList.length == 0"
                    >暂无数据</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="Size" label="文件大小" align="left">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.DocumentList" :key="item.uid">
                    <!-- <div
                      style="
                        width: calc(100% - 120px);
                        display: flex;
                        align-items: center;
                      "
                    >
                      {{ item.resname }}
                    </div> -->
                    <el-button type="text" style="color: #000; cursor: default">
                      {{ setSize(item.size) }}
                    </el-button>
                  </div>
                  <span v-if="scope.row.DocumentList.length == 0"
                    >暂无数据</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="上传状态" width="100" align="center">
                <template slot-scope="scope">
                  <i
                    class="el-icon-circle-check"
                    style="font-size: 20px; color: #67c23a"
                    v-if="
                      scope.row.DocumentList?.length > 0 &&
                      scope.row.DocumentList?.every(
                        (item) => item.status === 'success'
                      )
                    "
                  ></i>
                  <i
                    v-else
                    class="el-icon-circle-close"
                    style="font-size: 20px; color: #f56c6c"
                  ></i>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="
                display: flex;
                width: 100%;
                font-size: 14px;
                margin-top: 20px;
                margin-bottom: 10px;
              "
              v-if="approvalComments[eell.Type]"
            >
              <span
                style="
                  display: inline-block;
                  width: 130px;
                  font-weight: bold;
                  display: flex;
                  align-items: center;

                  margin-right: 10px;
                  padding-left: 20px;
                "
                >审核意见</span
              >
              <el-input
                v-model="approvalComments[eell.Type].content"
                placeholder="未输入内容"
                style="width: calc(100% - 150px)"
                type="textarea"
                :rows="2"
                :disabled="!(Status == 1 && !signInfo.PropertyReviewName)"
                resize="none"
                size="mini"
              ></el-input>
            </div>
          </div>
          <div class="form" style="margin-top: 10px">
            <el-form ref="form" :model="signInfo" label-width="100px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="">
                    <span
                      slot="label"
                      style="font-weight: bold; font-size: 16px"
                    >
                      业主：
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <span
                      slot="label"
                      style="font-weight: bold; font-size: 16px"
                    >
                      顾问公司：
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="姓名：">{{
                    signInfo?.PropertyReviewName
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="姓名："
                    >{{ signInfo?.ExamineName }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="签名：">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        box-sizing: border-box;
                        overflow: hidden;
                        width: 200px;
                        height: 100px;
                      "
                      v-if="signInfo?.PropertyReviewSign"
                    >
                      <el-image
                        :src="signInfo?.PropertyReviewSign"
                        alt=""
                        style="
                          width: 100%;
                          height: 100%;
                          background: #fff;
                          box-sizing: border-box;
                        "
                      />
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="签名：">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        box-sizing: border-box;
                        overflow: hidden;
                        width: 200px;
                        height: 100px;
                      "
                      v-if="signInfo?.Sign"
                    >
                      <el-image
                        :src="signInfo?.Sign"
                        alt=""
                        style="
                          width: 100%;
                          height: 100%;
                          background: #fff;
                          box-sizing: border-box;
                        "
                      />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="日期：">
                    {{
                      signInfo.PropertyReviewDate
                        ? moment(signInfo.PropertyReviewDate).format(
                            'YYYY-MM-DD'
                          )
                        : ''
                    }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="日期：">
                    {{
                      signInfo.ExamineTime
                        ? moment(signInfo.ExamineTime).format('YYYY-MM-DD')
                        : ''
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row style="margin-top: 30px">
                <el-col :span="12">
                  <el-form-item label="提交人：">
                    {{ rowItem.SupplierName || '' }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提交日期：">
                    {{
                      rowItem.InforTime
                        ? moment(rowItem.InforTime).format('YYYY-MM-DD')
                        : ''
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div style="width: 220px; margin-left: 20px" class="steps-box">
          <div
            v-for="(ele, index) in ProjectTableData"
            :key="ele.Type"
            :style="`height: calc(100% / ${ProjectTableData.length});min-height: 150px;`"
          >
            <div style="height: 100%; display: flex">
              <div class="steps-left">
                <div
                  :class="[
                    'steps',
                    ele.DocumentList?.length > 0 ? 'steps-success' : '',
                  ]"
                >
                  <i
                    class="el-icon-check"
                    v-if="ele.DocumentList?.length > 0"
                  ></i>
                  <span v-else>{{ index + 1 }}</span>
                </div>
                <div
                  :class="[
                    'steps-left-line',
                    ele.DocumentList?.length > 0 ? 'steps-success-line' : '',
                  ]"
                  v-if="index != ProjectTableData.length - 1"
                ></div>
              </div>
              <div class="steps-right">
                <div class="steps-right-title">
                  <span
                    :class="[
                      ele.DocumentList?.length > 0 ? 'steps-success' : '',
                    ]"
                    style="cursor: pointer"
                    >{{ index + 1 }}.{{ ele.TypeName }}</span
                  >
                  <!-- <el-button
                    type="text"
                    size="mini"
                    @click.stop="openApprovalDialog(ele.Type, index)"
                    style="margin-left: 10px; padding: 0 8px"
                    v-if="Status == 1"
                  >
                    批注
                  </el-button> -->
                </div>
                <!-- <div
                  class="steps-right-description"
                  v-if="approvalComments[ele.Type]"
                >
                  <div class="approval-comment">
                    <el-tooltip
                      effect="dark"
                      placement="left"
                      :open-delay="300"
                    >
                      <div slot="content" style="width: 300px">
                        {{ approvalComments[ele.Type].content }}
                      </div>
                      <div class="comment-content">
                        {{ approvalComments[ele.Type].content }}
                      </div>
                    </el-tooltip>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-loading="drawerLoading"
        v-if="Status == 1 && !signInfo.PropertyReviewName"
        style="
          font-size: 12px;
          color: #999;
          width: 100%;
          text-align: right;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-button
          type="success"
          @click="Audit(3, '审核')"
          style="margin-right: 10px"
          >通过</el-button
        >
        <el-button
          type="danger"
          @click="Audit(4, '驳回')"
          style="margin-right: 20px"
          >驳回</el-button
        >
      </div>
    </el-drawer>
    <el-dialog
      title="请输入驳回原因"
      :visible.sync="rejectVisible"
      width="400px"
      top="20vh"
      @close="rejectVisible = false"
    >
      <el-input
        type="textarea"
        :rows="9"
        placeholder="请输入内容"
        v-model="rejectValue"
      >
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="Audit(4, '审核', true)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <InfoStatistic ref="InfoStatistic"></InfoStatistic>
    <el-dialog
      title="批注"
      :visible.sync="approvalDialogVisible"
      width="500px"
      top="15vh"
    >
      <div class="approval-dialog-content">
        <div class="step-info">
          <span class="step-name">{{ currentStepName }}</span>
        </div>
        <el-input
          type="textarea"
          :rows="8"
          placeholder="请输入批注"
          v-model="approvalComment"
          maxlength="500"
          show-word-limit
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approvalDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveApprovalComment">确 定</el-button>
      </span>
    </el-dialog>
    <SignDialog ref="SignDialog"></SignDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as echarts from 'echarts'
import InfoStatistic from './InfoStatistic.vue'
import SignDialog from '@/components/SignDialog/SignDialog.vue'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      echarts,
      drawer: false,
      drawerLoading: false,
      ProjectTableData: [],
      ProjectStepList: [],
      dataStatistics: {},
      dataList: [],
      searchData: {
        SupplierName: '',
      },
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      info: {},
      rowItem: {},
      title: '',
      disabled: false,
      backName: '',
      pId: '',
      SupplierId: '',
      dataStatisticsLoading: false,
      rejectVisible: false,
      rejectValue: '',
      currentStepKey: '',
      currentStepName: '',
      approvalComment: '',
      approvalComments: {},
      approvalDialogVisible: false,
      signInfo: {},
      Status: null,
      SupplyType: '',
    }
  },
  props: {},
  components: { InfoStatistic, SignDialog },
  methods: {
    // 打开审批批注弹窗
    openApprovalDialog(stepKey, stepIndex) {
      this.currentStepKey = stepKey
      this.currentStepName = `${this.ProjectTableData[stepIndex].TypeName}`
      this.approvalComment = this.approvalComments[stepKey]?.content || ''
      this.approvalDialogVisible = true
    },
    // 保存审批批注
    saveApprovalComment() {
      if (!this.approvalComment.trim()) {
        return this.$notify.error('审批批注不能为空')
      }

      // 保存审批批注到本地数据
      this.$set(this.approvalComments, this.currentStepKey, {
        content: this.approvalComment.trim(),
        stepName: this.currentStepName,
        stepKey: this.currentStepKey,
      })

      // this.$notify.success("审批批注保存成功");
      this.approvalDialogVisible = false
      this.approvalComment = ''
    },
    openInfo(row) {
      this.$refs.InfoStatistic.openDrawer({
        ProjectId: this.pId,
        InforType: 3,
        SupplierId: this.SupplierId,
      })
    },
    getTotalInfo() {
      this.dataStatisticsLoading = true
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'ProjectDocumentSupplierStatistics',
          ProjectId: this.pId,
          SupplierId: this.SupplierId,
        })
        .then((res) => {
          this.dataStatisticsLoading = false
          if (res.Success) {
            if (!res.Data) {
              return
            }
            this.dataStatistics = res.Data
            this.$nextTick(() => {
              for (let index = 0; index < 2; index++) {
                var chartDom = document.getElementById(
                  index == 0 ? 'DeviceProgress' : 'DocumentProgress'
                )
                var myChart = echarts.init(chartDom)
                var option
                option = {
                  tooltip: {
                    formatter: '{a} : {c}%',
                  },
                  series: [
                    {
                      name: index == 0 ? '提交率' : '通过率',
                      type: 'gauge',
                      startAngle: 180,
                      endAngle: 360,
                      min: 0,
                      max: 100,
                      splitNumber: 10,
                      radius: '100%',
                      progress: {
                        show: true,
                        width: 5, //进度条宽度
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },

                        roundCap: true,
                      },
                      // 外层轴线
                      axisLine: {
                        lineStyle: {
                          width: 5,
                        },
                      },
                      axisTick: {
                        //刻度线
                        show: true,
                        distance: 1,
                        length: 2,
                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      splitLine: {
                        //表盘内刻度文字上刻度线
                        distance: 1,
                        show: true, // 显示分割线
                        length: 4, // 分割线长度，可以根据需要调整

                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      axisLabel: {
                        //表盘内刻度文字
                        distance: 6,
                        color: '#999',
                        fontSize: 8,
                      },
                      // center: ["50%", "50%"],
                      // radius: "90%",
                      pointer: {
                        width: 2, // 指针宽度，可以根据需要调整
                        length: '70%', // 指针长度，可以根据需要调整为百分比或具体数值
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },
                      },
                      detail: {
                        formatter: '{value}%',
                        textStyle: {
                          fontSize: 12,
                          color: '#333',
                        },

                        offsetCenter: [0, 10], // 详细指标位置，可以根据需要调整
                      },

                      data: [
                        {
                          value:
                            index == 0
                              ? this.dataStatistics.DeviceProgress || 0
                              : this.dataStatistics.DocumentProgress || 0,
                          // name: index == 0 ? "设备提交率" : "文档通过率",
                        },
                      ],
                    },
                  ],
                }
                console.log(option, 'option')
                console.log(myChart, 'myChart')
                option && myChart.setOption(option)
              }
            })
          } else {
            this.dataStatistics = {}
            this.$notify.error(res.Msg)
          }
        })
    },
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    subreject() {},
    async Audit(num, strn, isreject) {
      let arrlist = Object.values(this.approvalComments)
      console.log(arrlist, 'arrlist')
      if (num == 4) {
        if (arrlist.length == 0) {
          return this.$notify.error('请填写审批批注')
        }
      }

      let res = null
      this.drawerLoading = true
      try {
        res = await this.$http.post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'CheckSign',
          ProjectId: this.pId,
          SupplierId: this.rowItem.SupplierId,
          Status: num,
          RejectReason: arrlist.length == 0 ? '' : JSON.stringify(arrlist),
          UserId: this.userInfo.Id,
        })
        this.drawerLoading = false
        if (!res.Success) {
          this.$refs.SignDialog.openDialog()
          return
        }
      } catch (error) {
        this.drawerLoading = false
        this.$notify.error(res.Msg)
      }
      this.$confirm(
        `将${num == 2 ? '审核通过' : '驳回'}该供应商资质, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.drawerLoading = true
        this.$http
          .post(`/PB/PB_Project/GetProjectPanelData`, {
            Panel: 'ProjectSupplierQualificationsToExamine',
            ProjectId: this.pId,
            SupplierId: this.rowItem.SupplierId,
            Status: num,
            RejectReason: arrlist.length == 0 ? '' : JSON.stringify(arrlist),
            UserId: this.userInfo.Id,
          })

          .then((res) => {
            this.drawerLoading = false
            if (res.Success) {
              this.$notify.success(res.Msg)
              this.drawer = false
              this.getDataList()
              this.getTotalInfo()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    //字节转换
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    handlePreview(file) {
      console.log(file)
      window.open(file.url || file.response.Url)
    },
    openView(row) {
      this.title = '供应商资质详情---' + row.SupplierName
      this.rowItem = row
      this.drawer = true
      this.disabled = true
      this.getitemInfor()
    },
    auditView(row) {
      this.title = '供应商资质---' + row.SupplierName
      this.rowItem = row
      this.drawer = true
      this.disabled = false
      this.getitemInfor()
    },
    getitemInfor() {
      this.drawerLoading = true

      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'GetProjectSupplierQualificationsFiles',
          ProjectId: this.pId,
          SupplierId: this.SupplierId,
        })
        .then((res) => {
          this.drawerLoading = false
          if (res.Success) {
            this.ProjectTableData = res.Data.TableData
            this.ProjectStepList = res.Data.TypeData || []
            this.ProjectStepList.forEach((item) => {
              this.$set(this.approvalComments, item.DicValue, {
                content: '',
                stepName: item.DicName,
                stepKey: item.DicValue,
              })
            })
            this.signInfo = res.Data.ExamineData || {}
            this.Status = res.Data.Status || null
            if (
              res.Data.ApprovalCommentsData &&
              JSON.parse(res.Data.ApprovalCommentsData).length > 0
            ) {
              JSON.parse(res.Data.ApprovalCommentsData).forEach((item) => {
                this.$set(this.approvalComments, item.stepKey, item)
              })
              console.log(this.approvalComments, 'this.approvalComments')
            }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    Search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'ProjectDocument',
          ProjectId: this.pId,
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SupplierId: this.SupplierId,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataList = res.Data
            this.pagination.total = res.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    // this.pId = this.$route.query.id
    // this.backName = window.localStorage.getItem('ProjectName') || ''
    // this.SupplierId = this.$route.query.ParentId
    // this.getDataList()
    // this.getTotalInfo()
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    $route: {
      handler(n, o) {
        this.pId = n.query.id
        if (n.query.ParentId === this.SupplierId) {
          return
        }
        this.SupplierId = n.query.ParentId
        this.SupplyType = n.query.SupplyType || ''
        this.backName = window.localStorage.getItem('ProjectName') || ''

        this.getDataList()
        this.getTotalInfo()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}
::v-deep .con .number {
  color: #e6a23c;
}
.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
::v-deep .headData .el-card__body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.steps-box {
  .steps-left {
    width: 25px;
    height: 100%;
    margin-right: 10px;
    .steps {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 2px solid #c0c4cc;
      color: #c0c4cc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .steps-success {
      border: 2px solid #67c23a;
      color: #67c23a;
      font-size: 18px;
    }
    .steps-left-line {
      width: 2px;
      height: calc(100% - 25px);
      background: #c0c4cc;
      margin: 0 auto;
    }
    .steps-success-line {
      background: #67c23a;
    }
  }
  .steps-right {
    width: calc(100% - 35px);
    height: 100%;
    // overflow-y: auto;
    position: relative;
    .steps-success {
      color: #67c23a;
    }
    .steps-right-title {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // position: sticky;
      // top: 0;
      // background: #fff;
      // z-index: 1;
    }
    .steps-right-description {
      font-size: 14px;

      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 5px;
      padding-right: 5px;
      height: calc(100% - 45px);
      overflow: hidden;
      position: relative;
      .comment-content {
        line-height: 1.6;
        color: #303133;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f7fa;
        border-radius: 4px;
      }
    }
  }
}
// 审批批注弹窗样式
.approval-dialog-content {
  .step-info {
    margin-bottom: 16px;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-left: 4px solid #409eff;

    .step-name {
      font-weight: bold;
      color: #303133;
    }
  }
}
</style>
